import { createContext, Dispatch, SetStateAction, useContext } from "react";

export interface AnchorLink {
    anchor: string;
    id: string;
    label: string;
}

export interface AnchorContextModel {
    links: AnchorLink[];
    setLinks: Dispatch<SetStateAction<AnchorContextModel["links"]>>;
}

export const AnchorContext = createContext<AnchorContextModel>({} as any);
export const useAnchorContext = () => useContext(AnchorContext);
